import { api } from '@/shared/api/http'
import type { ProviderId } from '@/shared/ui/providers'
import type { LoginMethods } from './types'

/**
 * 계정에 붙은 로그인 방법을 읽는다.
 *
 * 내 정보 조회에 싣지 않는다. 이 값을 그리는 화면이 설정 하나뿐이라 화면을 옮길 때마다 도는
 * 응답에 얹을 까닭이 없다. 표시 이름을 따로 읽는 것과 같은 판단이다.
 */
export function fetchLoginMethods(signal?: AbortSignal): Promise<LoginMethods> {
  return api.get<LoginMethods>('/me/login-methods', signal ? { signal } : {})
}

/**
 * 이 왕복이 어느 화면에서 떠나는지.
 *
 * 왕복을 마친 브라우저가 돌아올 자리를 Backend가 이 값으로 고른다. 설정에서 떠난 왕복은 설정으로,
 * 가입 직후 권유 화면에서 떠난 왕복은 홈 주소로 온다.
 */
export type LinkOrigin = 'settings' | 'onboarding'

/**
 * 계정에 provider를 잇는 왕복으로 떠나는 자리.
 *
 * 로그인 왕복과 경로가 갈린다. 저장된 값으로만 의도를 가르면 로그인에서 시작한 왕복이 연결로
 * 흘러가는 실수를 코드가 막지 못한다. Backend가 provider로 302를 내리므로 fetch로 부르지 않고
 * 문서를 통째로 옮긴다.
 *
 * 화면 언어를 싣지 않는다. 이 왕복으로는 계정이 서지 않아 이름을 지을 일이 없다.
 */
export function identityLinkAuthorizeUri(provider: ProviderId, from: LinkOrigin): string {
  return `/api/v1/auth/${provider}/link/authorize?from=${from}`
}

export function startIdentityLink(provider: ProviderId, from: LinkOrigin): void {
  window.location.assign(identityLinkAuthorizeUri(provider, from))
}
